import { ThemeComponent } from "@/theme/ThemeComponent";

export class DrawerClose extends ThemeComponent {
    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.addEventListener("click", this.closeDrawer.bind(this));
    }

    closeDrawer(ev: { preventDefault(): void }) {
        ev.preventDefault();
        const closeButton = document.querySelector(
            'drawer-container[open=true] [data-ref="closeButton"]'
        ) as HTMLButtonElement;
        if (closeButton) { closeButton.click(); }
    }
}
